import { render, staticRenderFns } from "./HealthHistory.vue?vue&type=template&id=0a9204ee&scoped=true"
import script from "./HealthHistory.vue?vue&type=script&lang=ts"
export * from "./HealthHistory.vue?vue&type=script&lang=ts"
import style0 from "./HealthHistory.vue?vue&type=style&index=0&id=0a9204ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9204ee",
  null
  
)

export default component.exports